import { gql } from 'graphql-request';

import type { RequestDocument } from 'graphql-request';

export const COMPOSITION_TEMPLATE_QUERY_FRAGMENT = `{
      id
      label
      internalName
      placement
      overlapBefore
      overlapAfter
      isFullscreen
      aspectRatio
      source
      controls
      sixteenByNine
      nineBySixteen
      oneByOne
      isGlobalPreset
      compositionType
      isQuoteCard
      parentComposition {
        id
      }
      isDeleted
      thumbnail {
        id
        url
      }
    }
`;

export const COMPOSITION_TEMPLATES_QUERY: RequestDocument = gql`
  query CompositionTemplatesAll($isQuoteCard: BooleanType = false, $first: IntType, $skip: IntType) {
    allCompositions(first: $first, skip: $skip, filter: {
        isDeleted: { eq: false },
        isGlobalPreset: { eq: true }
        isQuoteCard: { eq: $isQuoteCard }
    }) ${COMPOSITION_TEMPLATE_QUERY_FRAGMENT}
  }
`;

export const COMPOSITION_BY_IDS_TEMPLATES_QUERY: RequestDocument = gql`
  query CompositionTemplatesByIds($ids: [ItemId!], $isQuoteCard: BooleanType = false, $first: IntType, $skip: IntType) {
    allCompositions(first: $first, skip: $skip, filter: { id: { in: $ids }, isDeleted: { eq: false }, isQuoteCard: { eq: $isQuoteCard } }) ${COMPOSITION_TEMPLATE_QUERY_FRAGMENT}
  }
`;
export default COMPOSITION_TEMPLATES_QUERY;
